import { useState, React, useEffect, Suspense, lazy, useTransition } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import { getbranchData, handleLogin } from "../../../redux/authentication";
//import bcrypt from "bcryptjs"; // Use a client-side hashing library like bcryptjs
import { 
 
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Container, Row, Col, Spinner, Card } from "react-bootstrap";
import { handleError } from "../../../redux/inventory";
import Header from "../../../paupet/Header";
import Home from "./Home";
import { LogIn } from "react-feather";
import axios from "axios";
import LogoMarquee from "./LogoMarquee";
import OtpModal from "./OTPModal"; // Adjust the path if necessary
//const LoginModal = lazy(() => import("./LoginModal"));
import LoginModal from "./LoginModal"; // Adjust the path if necessary
const PaupetSoft = lazy(() => import("../PaupetSoft"));
// Lazy load the OTP modal
//const OtpModal = lazy(() => import("./OTPModal")); // Adjust the path if necessary
const ContactForm = lazy(() => import("./ContactForm")); // Adjust the path if necessary
const Footer = lazy(() => import("./Footer")); // Adjust the path if necessary

const Login = ({ setUserRights }) => {
  const [isPending, startTransition] = useTransition();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [branch, setBranch] = useState("");
  //const { setUserRights } = useUser();
  const [loginUserRights, setLoginUserRights] = useState("");
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [toggleLogin, setToggleLogin] = useState(false);
  const [otpStatus, setOtpStatus] = useState("NA");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState("");
  const [otpDetails, setOTPDetails] = useState("");

    // Defined brand color for easy reference
  const brandNavy = "#344e66";


  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const passedAuthenticationHandler = async (dataArg) => {
    let collegeErpToken = null;

  // Attempt to fetch the secondary/College ERP token using the same branch context
  try {
    const erpResponse = await axios.post(
      `${process.env.REACT_APP_COLLEGE_ERP_API}auth`,
      { username, password, branch: branch === "RehobothLife" ? "RehobothPharma" : branch }, // or pass formData as required by your College ERP endpoint
      { headers: { "Content-Type": "application/json" } }
    );

    if (erpResponse.data && erpResponse.data.token) {
      collegeErpToken = erpResponse.data.token;
      // Store secondary token in session storage for application-wide access
      sessionStorage.setItem("collegeErpToken", JSON.stringify(collegeErpToken));
    }
  } catch (error) {
    console.error("Failed to retrieve secondary ERP token:", error);
  }

  // Continue with primary user log and Redux state updates
  userLogHandler(dataArg.token);
  dispatch(handleLogin({ ...dataArg, branch, collegeErpToken }));
  dispatch(getbranchData({ token: dataArg.token, branch }));

  sessionStorage.setItem("token", JSON.stringify(dataArg.token));
  sessionStorage.setItem("branch", JSON.stringify(branch));
  sessionStorage.setItem("username", JSON.stringify(username));
  setLoginUserRights(dataArg.rights);
  sessionStorage.setItem("rights", JSON.stringify(dataArg.rights));
  
  };

  const handleOtpSubmit = (otp) => {
    return fetch(`${process.env.REACT_APP_CRI_API}verify-otp`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${data.token}`,
      },
      body: JSON.stringify({
        token: otpDetails.token,
        otp: otp && otp.trim(),
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res?.data?.message === "Verified") {
          passedAuthenticationHandler(data);
          return { success: true }; // Return success response
        } else {
          return {
            success: false,
            message: res?.data?.message || "Invalid or expired OTP",
          };
        }
      })
      .catch((err) => {
        console.log(err);
        return {
          success: false,
          message: "An error occurred. Please try again.",
        };
      });
  };

  useEffect(() => {
    if ((loginUserRights && otpStatus === "NA") || otpStatus === "Successful") {
      setUserRights(loginUserRights);
      console.log(loginUserRights, data);
      // Handle successful login

      if (selectedRoute === "que") {
        navigate("/que-sys", {
          replace: true,
          state: { ...data, branch },
        });
        return;
      }
      if (selectedRoute === "feed") {
        navigate("/feedback", {
          replace: true,
          state: { ...data, branch },
        });
        return;
      }
      if (data.rights === "Accounts") {
        navigate("/phmcy-admin", {
          replace: true,
          state: { ...data, branch },
        });
        return;
      } else if (data.rights === "Doctor") {
        navigate("/trtmnt", {
          replace: true,
          state: { ...data, branch, username },
        });
        return;
      } else if (data.rights === "care") {
        navigate("/ccare", {
          replace: true,
          state: { ...data, branch, username },
        });
      } else if (data.rights === "Admin" || data.rights === "Manager") {
        navigate("/reports", {
          replace: true,
          state: { ...data, branch },
        });
      } else if (data.rights === "Reception") {
        navigate("/crm-clt", {
          replace: true,
          state: { ...data, branch },
        });
      } else if (data.rights === "ITAdmin") {
        navigate("/admin", {
          replace: true,
          state: { ...data, branch },
        });
      } else if (data.rights === "Customer") {
        navigate("/customer_form", {
          replace: true,
          state: { ...data, branch },
        });
      } else if (branch === "UAE" && username === "admin") {
        navigate("/crm", { replace: true, state: { ...data, branch } });
      }
    }
    //  else if (selectedRoute === "que") {
    //   navigate("/que-sys", {
    //     replace: true,
    //     state: { ...data, branch },
    //   });
    //   return;
    // }
  }, [setUserRights, loginUserRights, data.token, data.rights, otpDetails]);

  useEffect(() => {
    dispatch(handleError());
  }, [username]);

  useEffect(() => {
    //   if (!latitude && !longitude) {
    getLocation();
    setLoading(false);
    //   }
  }, [latitude, longitude]);

  const getLocationDetails = (latitude, longitude) => {
    const nominatimUrl = `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`;

    fetch(nominatimUrl)
      .then((response) => response.json())
      .then((data) => {
        const city =
          data.address.city || data.address.town || data.address.village;
        const state = data.address.state;
        const country = data.address.country;
        //   console.log(state, country, city);
      })
      .catch((error) => console.error("Error with Nominatim API:", error));
  };

  const isWithinRange = (lat1, lon1, lat2, lon2, radius) => {
    const R = 6371; // Earth's radius in km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in km
    return distance <= radius;
  };

  const getLocation = () => {
    const storedLocation = sessionStorage.getItem("userLocation");

    if (storedLocation) {
      const { latitude, longitude } = JSON.parse(storedLocation);
      setLatitude(latitude);
      setLongitude(longitude);
      getLocationDetails(latitude, longitude);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        // Cache the location in session storage
        sessionStorage.setItem(
          "userLocation",
          JSON.stringify({ latitude, longitude })
        );
        setLatitude(position.coords.latitude);
        setLongitude(position.coords.longitude);

        getLocationDetails(latitude, longitude);
      },
      (error) => {
        console.error("Error getting geolocation:", error);
      }
    );
  };

  const userLogHandler = (token) => {
    const timestamp = new Date();

    fetch(`${process.env.REACT_APP_CRI_API}add-userlog?branch=${branch}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        id: username,
        latitude,
        longitude,
        timestamp,
      }),
    });
  };

  const clearSession = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("branch");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("rights");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Clear session storage
    clearSession();

  // Define all allowed locations
const allowedLocations = [
  { lat: 11.2695802, lng: 75.7763289 },
  { lat: 11.269860,   lng: 75.776718 } // Added second location
];

// Check if within 5 km of AT LEAST ONE of the allowed locations
const withinAllowedRange = allowedLocations.some(location => 
  isWithinRange(location.lat, location.lng, latitude, longitude, 5)
);

if (
  !withinAllowedRange &&
  username !== "Anil" &&
  username !== "Neenus" &&
  branch === "CLT" &&
  username !== "Paul" &&
  username !== "Dr. Paul"
) {
  alert("Unauthorized Location");
  return;
}
   
    setLoading(true);
    // console.log(branch);
    // temp solution for clt or wrong branch

  //  if (
  //    branch &&
  //    branch !== "CLT" &&
  //    branch !== "Demo" &&
  //    branch !== "Carmel" &&
  //    branch !== "Kavitha"
  //  ) {
  //    alert("Enter branch correctly");
  //    setLoading(false);
  //    return;
  //  }
    if (!branch) {
      alert("Please select a branch");
      setLoading(false);
      return;
    }
    if (!username) {
      alert("Please enter username");
      setLoading(false);
      return;
    }
    if (!password) {
      alert("Please enter password");
      setLoading(false);
      return;
    }
    if (branch && username && password) {
      fetch(`${process.env.REACT_APP_CRI_API}auth`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ branch, username, password }),
      })
        .then((response) => {
          setLoading(false);
          //  console.log(response);

          if (response.error) {
            alert("Invalid Password");
            return;
          }
          return response.json();
        })
        .then((res) => {
          // console.log(res);
          if (res.error) {
            alert("Invalid Credentials");
            return;
          }
          //
          //  error: "Failed to verify password";
          setData(res);
          setLoading(false);
          //otpDetails.token
          if (res.otpSent === true && res.mobileNo) {
            setOTPDetails({
              token: res.otpDetails.token,
              mobile: res.otpDetails.mobileNo,
            });
            toggleModal();
          } else {
            passedAuthenticationHandler(res); // for time being without mobile/OTPs old users
            return;
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  return (
  <div style={{ background: "#ffffff", minHeight: "100vh", color: "#333" }}>
    <Header setToggleLogin={setToggleLogin} latitude={latitude} longitude={longitude} />

    <Container className="py-5">
      <Row className="align-items-center min-vh-75">
        {/* Centralized Hero Branding */}
      {/* Hero Section - Focused on Action */}
<Col lg={6} className="text-center text-lg-start mb-5 mb-lg-0">
  <motion.div
    initial={{ opacity: 0, x: -20 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.6 }}
  >
    {/* Branding moved to Header, keeping this section focused on utility */}
    <h1 className="display-4 fw-bold mb-3" style={{ color: brandNavy }}>
      Enterprise Management <br /> Simplified.
    </h1>
    <p className="lead text-secondary" style={{ fontSize: "1.1rem", maxWidth: "450px" }}>
      Access your operational dashboard securely. Engineered for precision, built for scale.
    </p>
  </motion.div>
</Col>

        {/* Login Card */}
        <Col lg={5} className="offset-lg-1">
          <Card className="border-0 shadow-sm rounded-0 p-4 border-start border-4" style={{ borderLeftColor: brandNavy }}>
            <Card.Body className="text-center">
              <h4 className="fw-bold mb-4" style={{ color: brandNavy }}>Secure Access Portal</h4>
              <button 
                className="btn btn-lg px-5 rounded-0"
                style={{ borderColor: brandNavy, color: brandNavy }}
                onMouseOver={(e) => { e.target.style.backgroundColor = brandNavy; e.target.style.color = "#fff"; }}
                onMouseOut={(e) => { e.target.style.backgroundColor = "transparent"; e.target.style.color = brandNavy; }}
                onClick={() => startTransition(() => setToggleLogin(!toggleLogin))}
              >
                <LogIn size={18} className="me-2" />
                Sign In
              </button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    {/* ✅ PLACE LOGO MARQUEE HERE */}
  {
    // <LogoMarquee />
  }
    {/* Components load cleanly below */}
    <motion.section initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}>
      <Container className="py-5">
        <Suspense fallback={<Spinner animation="border" style={{ color: brandNavy }} />}>
          <PaupetSoft />
          <Home />
          <ContactForm />
          <Footer />
        </Suspense>
      </Container>
    </motion.section>
 

      <AnimatePresence>
        {toggleLogin && (
          <LoginModal
            toggleLogin={toggleLogin}
            setToggleLogin={setToggleLogin}
            branch={branch}
            setBranch={setBranch}
            username={username}
            setUserName={setUserName}
            password={password}
            setPassword={setPassword}
            selectedRoute={selectedRoute}
            setSelectedRoute={setSelectedRoute}
            handleSubmit={handleSubmit}
            loading={loading}
          />
        )}
      </AnimatePresence>
    </div>
  );
 
};

export default Login;


       